import ResponseTargetingStepComponentBuilderView from './responseTargetingStepComponentBuilderView.html';
import { ResponseTargetingStepComponentBase } from '../responseTargetingStepComponentBase';
import '../responseTargetingStepComponent.scss';
import { StateViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/StateViewModel';
import { ActiveMessagesConstants } from '../../../ActiveMessagesConstants';
import { State } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/State';
import { isEmptyArray } from 'data/array';
import { CampaignType } from '../../../models/CampaignType';
import { RedirectType } from '../../../models/RedirectType';
export class ResponseTargetingBuilderStepComponentController extends ResponseTargetingStepComponentBase {
    static $inject = ['ActiveMessageService', 'ContextProcessorService', 'LoadingService', 'BuilderService', 'HostingService', 'ApplicationService2', 'BlipToastService', 'GrowthSegmentService', '$translate', 'AlertService'];
    constructor(ActiveMessageService, ContextProcessorService, LoadingService, BuilderService, HostingService, ApplicationService2, BlipToastService, GrowthSegmentService, $translate, AlertService) {
        'ngInject';
        super(ActiveMessageService, ContextProcessorService, LoadingService, BuilderService, HostingService, ApplicationService2, BlipToastService, GrowthSegmentService, $translate, AlertService);
        this.ActiveMessageService = ActiveMessageService;
        this.ContextProcessorService = ContextProcessorService;
        this.LoadingService = LoadingService;
        this.BuilderService = BuilderService;
        this.HostingService = HostingService;
        this.ApplicationService2 = ApplicationService2;
        this.BlipToastService = BlipToastService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.$translate = $translate;
        this.AlertService = AlertService;
        this.isWhatsAppGroup = false;
        this.isAiAgent = false;
        this.getData = () => {
            return {
                name: this.stepName,
                value: [],
                params: {
                    stateId: this.stateId,
                    template: this.application.template,
                    flowId: this.flowId,
                    attendanceRedirect: undefined,
                },
            };
        };
        this.getState = () => this.statesBotBuilder.find((x) => x.id === this.stateId);
        this.checkIfRedirectIsAllowed = () => {
            if (this.checkIfRedirectIsAllowedBase()) {
                return true;
            }
            if (this.campaignType == CampaignType.Batch && this.isAttendanceRedirect == RedirectType.Agent) {
                this.setRedirectType(RedirectType.Flow);
            }
            return false;
        };
        this.setRedirectType = async (value) => {
            await this.setRedirectTypeParent(value);
            this.stateDataOptions = this.generateStatesDataOptions(this.statesBotBuilder);
            this.hasStates = !isEmptyArray(this.stateDataOptions);
        };
        this.onChangeRedirectType = async (event) => {
            if (event.detail?.checked) {
                const target = event.target;
                await this.setRedirectType(target?.id);
            }
        };
        this.changeTarget = async (event) => {
            this.changeTargetParent(event.detail?.value);
            this.trackSelectedFlow(ActiveMessagesConstants.BUILDER);
        };
        this.checkContinueButtonBuilder = () => {
            return (this.checkContinueButton() && this.hasStates) || this.isWhatsAppGroup || this.isAiAgent;
        };
        this.statesBotBuilder = [];
    }
    async $onInit() {
        await this.initialize();
        this.labelBotState = await this.$translateParent('activeMessages.send.responseTargeting.select.labelState');
        this.hasStates = false;
        await this.loadBuilderConfiguration();
    }
    async getStatesBuilder() {
        const states = await this.ActiveMessageServiceParent.listStates(undefined, true);
        await Promise.all(states.items.forEach(state => {
            const converted = this.convertStateItem(state);
            const stateToUse = new State(converted);
            const stateViewModel = StateViewModel.create(stateToUse);
            stateViewModel.$title = state.longName;
            this.statesBotBuilder.push(stateViewModel);
        }));
    }
    handlePreviousStep() {
        this.previous();
    }
    async loadBuilderConfiguration() {
        await this.getStatesBuilder();
        this.stateDataOptions = this.generateStatesDataOptions(this.statesBotBuilder);
        this.hasStates = !isEmptyArray(this.stateDataOptions);
        this.flowId = await this.ActiveMessageServiceParent.getFlowId(undefined);
        this.extraDataModel = {
            value: this.stateId || '',
            label: this.stateId
                ? this.statesBotBuilder[this.stateId].$title
                : '',
        };
        if (this.stateId) {
            this.stateId = ActiveMessagesConstants.ONBOARDING_STATE;
        }
        this.oldStateId = this.stateId;
        this.isDeskIdInStateFlow = await this.checkIfDeskIdIsInStateFlow(this.statesBotBuilder);
    }
}
ResponseTargetingBuilderStepComponentController.$inject = ['ActiveMessageService', 'ContextProcessorService', 'LoadingService', 'BuilderService', 'HostingService', 'ApplicationService2', 'BlipToastService', 'GrowthSegmentService', '$translate', 'AlertService'];
export const ResponseTargetingBuilderStep = {
    template: ResponseTargetingStepComponentBuilderView,
    controller: ResponseTargetingBuilderStepComponentController,
    controllerAs: '$ctrl',
    bindings: {
        step: '@?',
        parent: '@?',
        next: '&?',
        previous: '&?',
        callback: '&?',
        campaignType: '@?',
        isBotRouter: '@?',
        errorAttendance: '@?',
        isWhatsAppGroup: '<?',
        isAiAgent: '<?',
    },
};
